<template>
    <nav class="nav">
        <img src="@/assets/logoWebeasyDark.svg" @click="goToHome" alt="logo_webeasy"/>
        <div class="nav-items" :class="{ open: isMenuOpen }">
            <ul>
                <li><a :class="{ current: isCurrentNav('/') }" href="/">{{$t('navbar.home')}}</a></li>
                <li><a :class="{ current: isCurrentNav('/works') }" href="/works">{{$t('navbar.works')}}</a></li>
                <li><a :class="{ current: isCurrentNav('/pricing') }" href="/pricing">{{$t('navbar.pricing')}}</a></li>
<!--                 <li><a :class="{ current: isCurrentNav('/services') }" href="#">{{$t('navbar.services')}}</a></li> -->
            </ul>
        <router-link to="/lets-talk">
          <ButtonComponent :msg="$t('navbar.talk')" />
        </router-link>
<!--             <ButtonComponent :msg="$t('navbar.talk')" href="mailto:hello@webeasy.pro" /> -->
                    <div class="lang-switcher">
          <button class="button" @click="switchLang">
            <span v-if="$i18n.locale === 'en'" class="" aria-label="Français"><span class="textButton">Français</span>  🇫🇷</span>
            <span v-else class="" aria-label="English"><span class="textButton">English</span> 🇺🇸</span>
          </button>
        </div>
        </div>
        <button class="menu-toggle" @click="toggleMenu" :aria-label="isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'">
            <span :class="{ open: isMenuOpen }"></span>
            <span :class="{ open: isMenuOpen }"></span>
            <span :class="{ open: isMenuOpen }"></span>
        </button>
    </nav>
</template>

<script>
import ButtonComponent from './ButtonComponent.vue';

export default {
    name: 'NavBar',
    components: {
        ButtonComponent
    },
    props: {
        msg: String
    },
    data() {
        return {
            isMenuOpen: false
        };
    },
    methods: {
        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        isCurrentNav(path) {
            return this.$route.path === path; // Utilisation de this.$route.path
        },
        goToHome() {
            this.$router.push('/');
        },
        switchLang() {
            this.$i18n.locale = this.$i18n.locale === 'en' ? 'fr' : 'en';
        },
    },
    watch: {
        $route() {
            // Forcer la mise à jour de la vue lorsque la route change
            this.$forceUpdate();
        }
    }
};
</script>

<style scoped>
img {
    cursor: pointer;
}
nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    margin-bottom: 40px;
    position: relative;
    z-index: 10; /* Ajout pour s'assurer que le menu est au-dessus */
}

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    gap: 40px;
    margin-right: 40px;
}

nav a {
    color: white;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s ease;
}

nav a:hover {
    color: #c6c6c6;
}

.nav-items {
    display: flex;
    align-items: center;
    transition: transform 0.3s ease, opacity 0.3s ease; /* Ajout pour une transition fluide */
    transform: translateY(-20px);
    opacity: 0;
}

.nav-items.open {
    transform: translateY(0);
    opacity: 1;
}

.menu-toggle {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
}

.menu-toggle span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: white;
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.menu-toggle span.open:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
}

.menu-toggle span.open:nth-child(2) {
    opacity: 0;
}

.menu-toggle span.open:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
}

.lang-switcher {
    margin-left: 20px;
  display: flex;
  align-items: center;
}

.lang-btn {
    color: white;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  outline: none;
}

@media (max-width: 768px) {
    .nav-items {
        position: absolute;
        top: 100%;
        right: 0;
        background: rgba(0, 0, 0, 0.163); /* Couleur de fond semi-transparente */
        backdrop-filter: blur(10px); /* Effet de flou */
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
        gap: 20px;
        display: none;
        z-index: 20; /* Ajout pour s'assurer que le menu est au-dessus */
        border-radius: 8px; /* Ajout pour des coins arrondis */
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Ajout d'une ombre pour un effet visuel */
    }

    .nav-items.open {
        display: flex;
    }

    ul {
        flex-direction: column;
        gap: 20px;
        margin-right: 0;
    }

    .menu-toggle {
        display: flex;
    }
    .lang-switcher {
    margin-left: 0px;
    }
}

@media (min-width: 769px) {
    .nav-items {
        transform: none; /* Réinitialise la transformation */
        opacity: 1; /* Rétablit l'opacité */
    }
}
.button {
  border: 1px solid #5294ff1e;
  background-color: #5294ff10;
  border-radius: 30px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 13px;
  padding-bottom: 13px;
  box-shadow: inset 0px 0px 14px 0px rgba(82, 148, 255, 0.049);
  backdrop-filter: blur(10px);
}
.button:hover {
  background-color: #5294ff20;
  box-shadow: inset 0px 0px 20px 0px rgba(82, 148, 255, 0.1);
  transform: scale(1.05);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.textButton {
  background: linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(163, 240, 248) 70%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
